module.exports = __webpack_public_path__ + "assets/img/btn-back-0e7ca18b.png";